export default {
  // conta dos investimentos
  page: 1,
  max_page: null,
  products: [],
  query: "",
  loader: true,
  favorite: [],
  ids_favorite: [],
  favorite_marketplace: [],
  qtd_filter: 0,
  list_mode: false,
  filters: [
    {
      name: "Caracteres",
      slug: "chars",
      value: "",
      type: "string",
      touched: false,
    },
    {
      name: "Capital recomendado (R$)",
      slug: "sugg_capital",
      min: 0,
      max: 250000,
      from: 0,
      to: 250000,
      step: 500,
      touched: false,
      type: "range",
    },
    {
      name: "Perda máxima diária (R$)",
      slug: "max_loss",
      value: 2000,
      min: 0,
      max: 10000,
      from: 0,
      to: 10000,
      step: 50,
      touched: false,
      type: "range",
    },
    {
      name: "Retorno total (%)",
      slug: "profit",
      value: 0,
      min: 0,
      max: 2000,
      from: 0,
      to: 2000,
      step: 10,
      touched: false,
      type: "range",
    },
    {
      name: "Taxa de acerto (%)",
      slug: "win_ratio",
      value: 0,
      min: 0,
      max: 100,
      from: 0,
      to: 100,
      step: 10,
      touched: false,
      type: "range",
    },
    {
      name: "Mercado",
      slug: "markets",
      items: [
        { displayName: "Futuro", value: "FUTURES" },
        { displayName: "À vista", value: "EQUITIES" },
        { displayName: "Cripto", value: "CRIPTO" },
      ],
      active: [],
      type: "tagbox",
    },
    {
      name: "Risco",
      slug: "risk",
      items: [
        { displayName: "Alto", value: "ALTO" },
        { displayName: "Médio", value: "MEDIO" },
        { displayName: "Baixo", value: "BAIXO" },
      ],
      active: [],
      type: "tagbox",
    },
    {
      name: "Nível",
      slug: "account_level",
      items: [
        { displayName: "Basic", value: "BASIC" },
        { displayName: "Pro", value: "PRO" },
        { displayName: "Max", value: "MAX" },
        { displayName: "Assinatura", value: "SUBSCRIPTION" },
      ],
      active: [],
      type: "select",
    },
    {
      name: "Timeframe",
      slug: "strategy_timeframe",
      items: [
        { displayName: "M1-M5", value: "M1_M5" },
        { displayName: "M6-M20", value: "M6_M20" },
        { displayName: "M30-H4", value: "M30_H4" },
      ],
      active: [],
      type: "select",
    },
    {
      name: "Estilo",
      slug: "strategy_style",
      items: [
        { displayName: "Day trade", value: "DAY_TRADE" },
        { displayName: "Swing trade", value: "SWING_TRADE" },
      ],
      active: [],
      type: "select",
    },
  ],

  partner_info: null,
  partnerSearchTerm: "",
};
